import React, { useState, useEffect } from "react";
import { Row, Col } from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import dayjs from "dayjs";
import "../.../../../Assets/Scss/CouponCardHorizontal.scss";
import styled, { keyframes } from "styled-components";
import { zoomIn } from "react-animations";
import ReactTooltip from "react-tooltip";
import { FaCheck } from "react-icons/fa";
import { AiOutlineCheckCircle } from "react-icons/ai";
import { Badge } from "react-bootstrap";
import { getCouponUrlAction } from "../../Store/couponUrl/actions";
import Loader from "./Loader";
import MonthYearMacros from "../Ui/MonthYearMacros";
import { useHistory } from "react-router-dom";
import redirectLogic from "../../Utils/redirectLogic";
import CentralCouponRedirect from "../../Utils/CentralCouponRedirectForSearchPage";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";

const zoomInAnimation = keyframes`${zoomIn}`;

const ZoomInDiv = styled.div`
  animation: 1s ${zoomInAnimation};
`;

const showCodeMargin = (length) => {
  if (length > 200) {
    return { marginBottom: "30%" };
  } else if (length > 250) {
    return { marginBottom: "35%" };
  }
};

function CouponCardHorizontal({ coupon, selectedStore }) {
  const dispatch = useDispatch();
  const history = useHistory();

  const { domainData } = useSelector((state) => state.Website);
  const { link } = useSelector((state) => state.CouponUrl);
  const [copyText, setCopyText] = useState(false);
  const [displayWidth, setDisplayWidth] = useState(0);
  const [useRedirectComponent, setUseRedirectComponent] = useState(false);

  const [redirect, setRedirect] = useState(false);
  const [redirect2, setRedirect2] = useState(false);
  const [loading, setLoading] = useState(false);
  const [newTab, setNewTab] = useState(false);
  const [second, setSecond] = useState(false);
  // const { storeName, couponId, redirectionType } = useParams();

  const copyMethod = (url) => {
    const protocol = window.location.protocol;
    const domain = window.location.hostname;
    const copyUrl = protocol + "//" + domain + url;
    const tempTextArea = document.createElement("textarea");
    tempTextArea.value = copyUrl;
    document.body.appendChild(tempTextArea);
    tempTextArea.select();
    document.execCommand("copy");
    document.body.removeChild(tempTextArea);
    alert("Text copied to clipboard");
  };

  useEffect(() => {
    setDisplayWidth(window.innerWidth);
  });
  useEffect(() => {
    getCouponUrlAction({ finalLink: coupon?.finalLink });
    localStorage.setItem("link", coupon?.finalLink);
    if (redirect) {
      setLoading(false);
      setNewTab(!newTab);
    }
    if (redirect2) {
      setLoading(false);
      setNewTab(!newTab);
    }
  }, [link, newTab, redirect, redirect2, second]);

  useEffect(() => {
    if (coupon?.finalLink && redirect) {
      setRedirect(false);
      window.open(`/mr/`, "_blank");
    }
    if (coupon?.finalLink && redirect2) {
      history.push(
        `/couponzr/store/${selectedStore.slug.replace(
          " ",
          ""
        )}/coupon/${selectedStore.slug.replace(" ", "")}/${coupon?._id}`
      );
      setRedirect2(false);
      window.open(coupon?.finalLink, "_blank");
    }
  }, [link, newTab, redirect, redirect2]);

  return (
    <>
      <ZoomInDiv style={{ marginTop:"0px"}} className="coupon mb-2">
        {useRedirectComponent && (
          <CentralCouponRedirect
            e={useRedirectComponent.e}
            coupon={useRedirectComponent.coupon}
            selectedStore2={selectedStore}
          ></CentralCouponRedirect>
        )}
        <div>
          <h3 className="heading" style={{ lineHeight: "23px" }}>
            {coupon?.title}
            {coupon?.tags &&
              coupon.tags.split(",").map((tag, index) => {
                return (
                  <Badge
                    bg="inf"
                    style={{
                      fontSize: ".8rem",
                      backgroundColor: domainData?.header_color,
                      color: "white",
                      float: "right",
                      marginLeft: "2px",
                    }}
                  >
                    {tag}
                  </Badge>
                );
              })}
          </h3>

          <Row style={{ display: "flex" }}>
            <Col
              xs={12}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                flexWrap: "wrap",
              }}
            >
              <div
                style={
                  displayWidth < 768 && coupon?.description?.length > 100
                    ? showCodeMargin(coupon?.description?.length)
                    : {}
                }
              >
                {" "}
                {coupon.description && (
                  <p className="descText" style={{ overflow: "auto" }}>
                    {/* {coupon?.description?.length > 150
                  ? coupon?.description?.substring(0, 150) + "..."
                  : coupon?.description} */}
                    <MonthYearMacros input={coupon.description} />
                  </p>
                )}
              </div>
              <br />

              <div>
                <div className="d-flex align-items-center justify-content-center">
                  <AiOutlineCheckCircle
                    title="Verified"
                    size="1em"
                    style={{ color: "green", fontWeight: "bold" }}
                  />
                </div>

                <Div
                  className="showCode  h-100 "
                  color={domainData?.header_color}
                >
                  <div
                    className="coupon-code btn"
                    // onClick={(e)=>
                    //   redirectLogic(
                    //   e,
                    //   setLoading,
                    //   dispatch,
                    //   getCouponUrlAction,
                    //   coupon,
                    //   selectedStore,
                    //   link,
                    //   setSecond,
                    //   setRedirect,
                    //   setRedirect2,
                    //   history
                    // )}
                    onClick={(e) => {
                      e.preventDefault();
                      setUseRedirectComponent({ e, coupon });
                    }}
                    style={{ margin: "0.5rem" }}
                  >
                    <span className="code-text" rel="nofollow">
                      {coupon?.coupon_code?.substring(
                        coupon?.coupon_code?.length - 4
                      )}
                    </span>{" "}
                    <span className="get-code">
                      {loading && <Loader />}
                      Show Code
                    </span>
                  </div>
                </Div>
              </div>
            </Col>
            <Col xs={12}>
              <div className="footerText">
                <span style={{display:coupon.expiry_date ? "solid":"none"}} className="Expiry">
                  Expiry : {dayjs(coupon?.expiry_date).format("DD MMM YYYY")}
                </span>

                <span
                  className="shareOffer"
                  data-tip="Copy"
                  data-event-off="click"
                  onClick={() => {
                    ReactTooltip.hide();
                    setCopyText(true);
                    setTimeout(() => {
                      setCopyText(false);
                    }, 2000);
                    localStorage.setItem("finalLink", coupon?.finalLink);
                    if (
                      coupon?.redirection_type === "zero-redirect-without-refer"
                    ) {
                      copyMethod(
                        `/mr/store/${selectedStore.slug}/coupon/${coupon?._id}/zdwor`
                      );
                    } else if (
                      coupon?.redirection_type === "zero-redirect-with-refer"
                    ) {
                      copyMethod(
                        `/mr/store/${selectedStore.slug}/coupon/${coupon?._id}/zrwr`
                      );
                    } else if (coupon?.redirection_type === "Meta") {
                      copyMethod(
                        `/couponsredirect/store/${
                          selectedStore.slug
                        }/coupon/${selectedStore.slug.replace(" ", "")}/${
                          coupon?._id
                        }/mtrd`
                      );
                    } else if (coupon?.redirection_type === "S2S") {
                      copyMethod(
                        `/couponsredirect/store/${
                          selectedStore.slug
                        }/coupon/${selectedStore.slug.replace(" ", "")}/${
                          coupon?._id
                        }/s2s`
                      );
                      // copyMethod(
                      //   `/mr/store/${selectedStore.slug}/coupon/${coupon?._id}/s2s`
                      // );
                    } else if (coupon?.redirection_type === "redirection") {
                      copyMethod(
                        `/couponsredirect/store/${
                          selectedStore.slug
                        }/coupon/${selectedStore.slug.replace(" ", "")}/${
                          coupon?._id
                        }`
                      );
                    } else if (
                      selectedStore?.v2_store?.[0]?.affiliate_network
                        ?.desktop_redirection_type ===
                      "zero-redirect-without-refer"
                    ) {
                      copyMethod(
                        `/mr/store/${selectedStore.slug}/coupon/${coupon?._id}/zdwor`
                      );
                    } else if (
                      selectedStore?.v2_store[0]?.affiliate_network
                        ?.desktop_redirection_type ===
                      "zero-redirect-with-refer"
                    ) {
                      copyMethod(
                        `/mr/store/${selectedStore.slug}/coupon/${coupon?._id}/zrwr`
                      );
                    } else if (
                      selectedStore?.v2_store?.[0]?.affiliate_network
                        ?.desktop_redirection_type === "Meta"
                    ) {
                      copyMethod(
                        `/couponsredirect/store/${
                          selectedStore.slug
                        }/coupon/${selectedStore.slug.replace(" ", "")}/${
                          coupon?._id
                        }/mtrd`
                      );
                    } else if (
                      selectedStore?.v2_store?.[0]?.affiliate_network
                        ?.desktop_redirection_type === "S2S"
                    ) {
                      copyMethod(
                        `/couponsredirect/store/${
                          selectedStore.slug
                        }/coupon/${selectedStore.slug.replace(" ", "")}/${
                          coupon?._id
                        }/s2s`
                      );
                      // copyMethod(
                      //   `/mr/store/${selectedStore.slug}/coupon/${coupon?._id}/s2s`
                      // );
                    } else {
                      copyMethod(
                        `/couponsredirect/store/${
                          selectedStore.slug
                        }/coupon/${selectedStore.slug.replace(" ", "")}/${
                          coupon?._id
                        }`
                      );
                    }
                  }}
                >
                  <span>Share Offer</span>
                </span>
                {/* Copied*/}
                {copyText && (
                  <span className="copyTextMain">
                    <span style={{ padding: "2px", color: "#4E944F" }}>
                      <FaCheck />
                    </span>
                    Copied
                  </span>
                )}
                <ReactTooltip className="customTooltipclass" />
              </div>
            </Col>
          </Row>
        </div>
      </ZoomInDiv>
    </>
  );
}

const Div = styled.div`
  .coupon-code {
    padding-left: 4.8rem;
    border: 2px solid #dddddd;
    background: linear-gradient(
        315deg,
        rgba(0, 0, 0, 0.06) 10%,
        transparent 15%,
        transparent 35%,
        rgba(0, 0, 0, 0.06) 40%,
        rgba(0, 0, 0, 0.06) 60%,
        transparent 65%,
        transparent 85%,
        rgba(0, 0, 0, 0.06) 90%
      )
      repeat scroll 0 0/6px 6px transparent;

    position: relative;
    width: 125px;
    height: 40px;
    overflow: hidden;
  }

  .get-code {
    position: absolute;
    border-radius: 4px 0 0 4px;
    left: -2px;
    top: -2px;
    padding: 0.5rem;
    background: ${(props) => props.color};
    color: #ffffff;
    text-align: right;
    line-height: 1.7;
    white-space: nowrap;
    height: calc(100% + 4px);
  }

  .get-code:after {
    content: "";
    display: block;
    width: 0;
    height: 100%;
    border-top: 43px solid transparent;
    border-left: 32px solid ${(props) => props.color};
    position: absolute;
    right: -32px;
    top: 0;
  }

  .get-code:hover {
    padding-right: 0.45px;
    transition: all 0.5s ease;
  }
`;

export default CouponCardHorizontal;
